var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuaifu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u900F\u660E\u5C42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 816,
    height: 554,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-6.0%",
    width: "109.6%",
    height: "114.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 360,
    height: 40,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684\\u8D26\\u6237",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1.2-\\u5957\\u9910\\u5F00\\u901A/\\u7ACB\\u5373\\u5F00\\u901A",
    transform: "translate(-758.000000, -465.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9875\\u9762\\u80CC\\u666F",
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u677F\\u5757/\\u5957\\u9910\\u5F00\\u901A",
    transform: "translate(152.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u677F\\u5757\\u80CC\\u666F",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 848,
    height: 1058,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5B57\\u6BB5/\\u5F00\\u901A\\u5DE5\\u53F7",
    transform: "translate(26.000000, 346.000000)",
    fill: "#000000",
    fillOpacity: 0.02,
    fillRule: "nonzero",
    stroke: "#000000",
    strokeOpacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8868\\u683C",
    transform: "translate(70.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M636,0.5 C636.966498,0.5 637.841498,0.891750844 638.474874,1.52512627 C639.108249,2.15850169 639.5,3.03350169 639.5,4 L639.5,4 L639.5,31.5 L0.5,31.5 L0.5,4 C0.5,3.03350169 0.891750844,2.15850169 1.52512627,1.52512627 C2.15850169,0.891750844 3.03350169,0.5 4,0.5 L4,0.5 Z",
    id: "\\u8868\\u683C\\u6807\\u9898"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "\\u906E\\u7F69",
    fillOpacity: 0.6,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5BF9\\u8BDD\\u6846/\\u8BA2\\u5355\\u652F\\u4ED8",
    transform: "translate(312.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BF9\\u8BDD\\u6846\\u80CC\\u666F"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u677F\\u5757/\\u652F\\u4ED8\\u65B9\\u5F0F",
    transform: "translate(430.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6807\\u7B7E/\\u5FEB\\u670D\\u901A\\u884C\\u8BC1\\u652F\\u4ED8",
    transform: "translate(2.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u677F\\u5757\\u80CC\\u666F"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#DA041B",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 359,
    height: 39,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#FEE7E6",
    strokeWidth: 2,
    x: -1,
    y: -1,
    width: 362,
    height: 42,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(14.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u900F\\u660E\\u5C42",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5FEB\\u670D\\u7F51\\u54C1\\u724C\\u6807\\u5FD7",
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LOGO\\u56FE\\u5F62\\u533A\\u57DF",
    x: 0,
    y: 0.0000458094244,
    width: 16,
    height: 11.9999542
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u6807\\u5FD7",
    transform: "translate(0.080091, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u5706",
    fill: "#FA8C16",
    cx: 9.19263636,
    cy: 10.8750043,
    rx: 1.09090909,
    ry: 1.12499571
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u5706",
    fill: "#FA8C16",
    cx: 3.28354545,
    cy: 10.8750043,
    rx: 1.09090909,
    ry: 1.12499571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7853636,0 L14.5856397,1.47444949 C14.379429,1.72788057 14.0700683,1.87499284 13.7433419,1.87499284 L12.8954872,1.87499284 L12.8954872,1.87499284 L12.2852145,2.62498998 L13.6493636,2.62498998 L12.4496397,4.09943947 C12.243429,4.35287055 11.9340683,4.49998282 11.6073419,4.49998282 L10.759669,4.49998282 L10.759669,4.49998282 L8.59036703,7.16604378 C8.33802592,7.47616971 7.88205628,7.52301356 7.57193035,7.27067244 C7.56626152,7.26605987 7.56066286,7.26136172 7.55513631,7.2565796 L6.58732081,6.41913175 L6.58732081,6.41913175 L11.4844602,0.400546547 C11.6906709,0.14711356 12.0000328,-8.96307555e-16 12.3267607,0 L15.7853636,0 L15.7853636,0 Z",
    id: "F",
    fill: "#CF1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10520009,2.35802301 L3.59925787,6.59099413 L3.59925787,6.59099413 L7.11054194,2.2755887 C7.31675259,2.02215363 7.62611576,1.87503865 7.95284526,1.87503865 L9.80990909,1.87503865 L9.80990909,1.87503865 L6.07490909,6.46520863 L9.4376129,9.37501002 L7.01366889,9.37501002 C6.75269781,9.37501002 6.50045522,9.28102564 6.3031108,9.11025947 L4.90627273,7.9015469 L4.90627273,7.9015469 L3.97994949,9.04012468 L3.96681924,9.05592147 C3.80020682,9.25153832 3.55585843,9.37501002 3.28354545,9.37501002 C2.88281216,9.37501002 2.54263839,9.10762219 2.421638,8.73641646 L0,1.87503865 L1.42254091,1.87503865 C1.72947259,1.87503865 2.00304292,2.06859086 2.10520009,2.35802301 Z",
    id: "K",
    fill: "#CF1322"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/\\u9762\\u578B/20\\xD720/\\u5FEB\\u670D\\u7F51",
    transform: "translate(14.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u900F\\u660E\\u5C42",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5FEB\\u670D\\u7F51\\u54C1\\u724C\\u6807\\u5FD7",
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "LOGO\\u56FE\\u5F62\\u533A\\u57DF",
    x: 0,
    y: 0.0000458094244,
    width: 16,
    height: 11.9999542
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u6807\\u5FD7",
    transform: "translate(0.080091, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u5706",
    fill: "#FA8C16",
    cx: 9.19263636,
    cy: 10.8750043,
    rx: 1.09090909,
    ry: 1.12499571
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u5706",
    fill: "#FA8C16",
    cx: 3.28354545,
    cy: 10.8750043,
    rx: 1.09090909,
    ry: 1.12499571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7853636,0 L14.5856397,1.47444949 C14.379429,1.72788057 14.0700683,1.87499284 13.7433419,1.87499284 L12.8954872,1.87499284 L12.8954872,1.87499284 L12.2852145,2.62498998 L13.6493636,2.62498998 L12.4496397,4.09943947 C12.243429,4.35287055 11.9340683,4.49998282 11.6073419,4.49998282 L10.759669,4.49998282 L10.759669,4.49998282 L8.59036703,7.16604378 C8.33802592,7.47616971 7.88205628,7.52301356 7.57193035,7.27067244 C7.56626152,7.26605987 7.56066286,7.26136172 7.55513631,7.2565796 L6.58732081,6.41913175 L6.58732081,6.41913175 L11.4844602,0.400546547 C11.6906709,0.14711356 12.0000328,-8.96307555e-16 12.3267607,0 L15.7853636,0 L15.7853636,0 Z",
    id: "F",
    fill: "#CF1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10520009,2.35802301 L3.59925787,6.59099413 L3.59925787,6.59099413 L7.11054194,2.2755887 C7.31675259,2.02215363 7.62611576,1.87503865 7.95284526,1.87503865 L9.80990909,1.87503865 L9.80990909,1.87503865 L6.07490909,6.46520863 L9.4376129,9.37501002 L7.01366889,9.37501002 C6.75269781,9.37501002 6.50045522,9.28102564 6.3031108,9.11025947 L4.90627273,7.9015469 L4.90627273,7.9015469 L3.97994949,9.04012468 L3.96681924,9.05592147 C3.80020682,9.25153832 3.55585843,9.37501002 3.28354545,9.37501002 C2.88281216,9.37501002 2.54263839,9.10762219 2.421638,8.73641646 L0,1.87503865 L1.42254091,1.87503865 C1.72947259,1.87503865 2.00304292,2.06859086 2.10520009,2.35802301 Z",
    id: "K",
    fill: "#CF1322"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuaifu);
export default __webpack_public_path__ + "static/media/kuaifu.1f67417b71fea05b9ad96a9108228ff8.svg";
export { ForwardRef as ReactComponent };